'use client';

import { useTranslations } from 'next-intl';
import { Clock, Eye, MessageCircle } from 'lucide-react';
import { LucideIcon } from '@/src/components/LucideIcon';
import type { PropertyDetailListing } from '@/src/components/features/property/types';
import { useContactFormAction } from '../ContactForm/useContactFormAction';
import { ctaButton, ctaEmphasis, row, rowIcon, rowList } from './competitionModule.styles';
import { getCompetitionDisplay } from './competitionModule.utils';

type Props = {
  listing: PropertyDetailListing;
};

export const CompetitionModule = ({ listing }: Props) => {
  const t = useTranslations('hdp');
  const display = getCompetitionDisplay(listing);
  const { openContactForm, contactFormOverlay, identityResolved } = useContactFormAction(listing);

  if (!display) return null;

  return (
    <>
      <ul className={rowList}>
        <li className={row}>
          <LucideIcon icon={Eye} size="sm" className={rowIcon} />
          <span>{t('competitionViewed', { count: display.viewed })}</span>
        </li>
        <li className={row}>
          <LucideIcon icon={MessageCircle} size="sm" className={rowIcon} />
          {display.inquiries > 0 ? (
            <span>{t('competitionContacted', { count: display.inquiries })}</span>
          ) : (
            <span>
              {t('competitionNoContacts')}{' '}
              {display.isActive && (
                <button
                  type="button"
                  className={ctaButton}
                  onClick={openContactForm}
                  disabled={!identityResolved}
                  aria-busy={!identityResolved}
                >
                  {t('competitionBeThe')} <span className={ctaEmphasis}>{t('competitionFirst')}</span>!
                </button>
              )}
            </span>
          )}
        </li>

        {display.lastContactedAgo && (
          <li className={row}>
            <LucideIcon icon={Clock} size="sm" className={rowIcon} />
            <span>{t('competitionLastContacted', { ago: display.lastContactedAgo })}</span>
          </li>
        )}
      </ul>
      {contactFormOverlay}
    </>
  );
};
